<template>
  <div class="p-15">
    <el-card>
      <el-form ref="ruleForm" :model="searchForm" inline>
        <el-form-item prop="query.content">
          <el-input placeholder="请输入内容" v-model.trim="searchForm.query.content">
            <el-select v-model="searchForm.query.field" slot="prepend" placeholder="请选择" style="width: 120px">
              <el-option v-for="item in select_options" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="resetPagination" type="primary">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button @click="handleExport(exportStockUrl)" type="primary">导出</el-button>
        </el-form-item>
        <el-form-item>
          <el-button @click="reset">重置</el-button>
        </el-form-item>
        <el-form-item class="fr">
          <import-export @success="init" :template="templateUrl" :target="exportStockUrl"></import-export>
        </el-form-item>
      </el-form>
    </el-card>
    <el-card class="m-t-20">
      <el-table :data="tableData">
        <el-table-column label="礼品名称/规格">
          <template slot-scope="{row}">
            <div v-if="row.gift" class="flex">
              <el-image :src="row.gift.photoUrls[0]" style="width: 50px;height: 50px" :preview-src-list="srcList"></el-image>
              <div class="m-l-10">
                <div>{{ row.gift.title }}</div>
                <div>{{ row.code }}:{{ row.gift.attr }}</div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="库存数" width="150" align="center">
          <template slot-scope="{row}">
            <el-input-number @change="handleStock(row)" v-model="row.stock" size="mini" :min="0"></el-input-number>
          </template>
        </el-table-column>
        <el-table-column label="占用" width="120" align="center" prop="hold"></el-table-column>
        <el-table-column label="剩余" width="120" align="center">
          <template slot-scope="{row}">
            {{ surplus(row) }}
          </template>
        </el-table-column>
      </el-table>
      <pagination :changed="changePage" :total="total" :pagination="searchForm.pagination"/>
    </el-card>
  </div>
</template>

<script>
import {exportStockUrl, getStockList, templateUrl, updateStock} from "@/api/gift";

export default {
  name: "stock",
  computed: {
    surplus() {
      return (row) => {
        let num = row.stock - row.hold
        return num > 0 ? num : 0
      }
    },
    srcList() {
      return this.tableData.map(item => {
        return item.gift ? item.gift.photoUrls[0] : ''
      })
    }
  },
  data() {
    return {
      searchForm: {
        query: {
          field: 'code',
          content: undefined,
        },
        pagination: {
          currentPage: 1,
          limit: 10
        }
      },
      select_options: [
        {label: '礼品编码', value: 'code'},
        {label: '礼品名称', value: 'title'},
      ],

      tableData: [],
      total: 0,

      templateUrl,
      exportStockUrl
    }
  },
  methods: {
    resetPagination() {
      this.searchForm.pagination = { currentPage: 1, limit: 10 }
      this.init()
    },
    async handleStock(row) {
      await updateStock(row)
      this.$message.success('操作成功')
    },
    changePage(page) {
      this.searchForm = Object.assign(this.searchForm, page)
      this.init()
    },
    reset() {
      this.$refs.ruleForm.resetFields()
      this.init()
    },
    async init() {
      const {collection, meta} = await getStockList(this.searchForm)
      this.tableData = collection
      this.total = meta.total
    }
  },
  mounted() {
    this.init()
  }
}
</script>

<style scoped>

</style>